import { axiosClient } from './axiosClient';
import {
  TClientManagement,
  TFacilityManagement,
  TGroupManagement,
} from '../types/clientManagement/clientManagement';
import { TOptionsQuery } from '../types/common';
import queryString from 'querystring';

export const surveyMasterApi = {
  getListSurveyMaster: () => {
    const url = '/survey-master';
    return axiosClient.get(url);
  },
};
